export default {
  SET_LANG: "SET_LANG",

  NAVBAR_TOGGLE_STYLE: "NAVBAR_TOGGLE_STYLE",
  LOGIN: "LOGIN",
  AUTO_LOGIN: "AUTO_LOGIN",
  LOGOUT: "LOGOUT",
  UPDATE_PROFILE: "UPDATE_PROFILE",
};
